module.exports = __webpack_public_path__ + "img/caution.0195317d.svg";